namespace advisorop.components.widgets {
    
    export class AdvisoropPanelController {        

        _loadingPanelId: string;
        public panelTitle;
        public showFooter = "false";
        // reference
        iAmReady: any; //event when controller has been initialised

        public set loadingPanelId(value: string) {
            // console.log(`Setting loading panel ID to: ${value}`);
            if (value) {
                if (value != this._loadingPanelId) {
                    this._loadingPanelId = value;
                    this.initLoadingPanel();
                }
            } else {
                this._loadingPanelId = null;
                this.loadingPanelOptions = null;
            }
        }
      
        isLoadingPanelVisible = false;
        loadingPanelOptions: DevExpress.ui.dxLoadPanelOptions;

        constructor() {
        }

        showHidePanel(event): void {

            event.preventDefault();

            var el = $(event.currentTarget || event.target);

            var hpanel = el.closest('div.hpanel');
            var icon = el.find('i:first');
            var body = hpanel.find('div.panel-body');
            var footer = hpanel.find('div.panel-footer');
            body.slideToggle(300);
            footer.slideToggle(200);

            // Toggle icon from up to down
            icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
            hpanel.toggleClass('').toggleClass('panel-collapse');
            setTimeout(function () {
                hpanel.resize();
                hpanel.find('[id^=map-]').resize();
            }, 50);
        };

        initLoadingPanel() {

            if (!this._loadingPanelId) {
                return;
            }

            const elId = `#${this._loadingPanelId}`;
            const jqEl = $(elId)
            
            this.loadingPanelOptions = {
                shadingColor: "rgba(0,0,0,0.4)",
                position: {
                    of: jqEl,
                    at: {
                        x: "center", y: "center"
                    },
                    // boundary: jqEl
                },
                showIndicator: true,
                showPane: true,
                shading: true,
                closeOnOutsideClick: false,
                message: "Please wait...",
                bindingOptions: {
                    visible: "vm.isLoadingPanelVisible"
                }
            };
            // this.showLoadingPanel = true;
        }

        showLoadingPanel() {
            // console.log(`Showing loading panel [${this._loadingPanelId}]`);
            this.isLoadingPanelVisible = true;
        }

        hideLoadingPanel() {
            // console.log(`Hiding loading panel [${this._loadingPanelId}]`);
            this.isLoadingPanelVisible = false;
        }
        
        $onInit() {
            this.iAmReady({ ctrl: this });
        }
    }
    
    class AdvisoropPanel implements ng.IComponentOptions {
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        public transclude;

        constructor() {
            this.bindings = {
                iAmReady: "&",
                panelTitle: "@",
                panelTitleBold: "@",
                showFooter: "@",
                loadingPanelId: "@"
            };
            this.transclude = {
                tools: "?panelTools",
                body: "?panelBody",
                footer: "?panelFooter"
            };
            this.controller = AdvisoropPanelController;
            this.controllerAs = "vm";
            this.templateUrl = 'spa/shared/common/advisorop-panel.html';    
        }
    }
    angular.module(Constants.APP).component("advisoropPanel", new AdvisoropPanel());
    
}